import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export default function OfficeBearers({ ObDetails, title }) {
  return (
    <section className="bg-[#0b0f19] text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">

        {/* Section Title */}
        <h2 className="text-2xl font-semibold mb-10">
          {title}
        </h2>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {ObDetails.map(({ name, designation, photo, linkedin }, index) => (
            <div
              key={index}
              className="group relative aspect-[3/4] rounded-xl overflow-hidden bg-[#111827]"
            >

              {/* Image */}
              <img
                src={photo || "/default-avatar.png"}
                alt={name}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />

              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-black/30" />

              {/* LinkedIn Icon */}
{linkedin && (
  <a
    href={linkedin}
    target="_blank"
    rel="noopener noreferrer"
    className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition hover:scale-110"
  >
    <LinkedInIcon
      sx={{
        fontSize: 32,
        color: "#ffffff",
        backgroundColor: "#0A66C2",
        borderRadius: "6px",
        padding: "4px",
        fill: "0A66C2"
      }}
    />
  </a>
)}
              {/* Name Card */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[85%] rounded-lg bg-white/15 backdrop-blur-md border border-white/20 px-4 py-3">
                <div className="text-base font-medium text-center">
                  {name}
                </div>
                <div className="text-sm text-white/70 text-center mt-1">
                  {designation}
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
